const COUNTRY_LIST = [ 
    {name: 'Afghanistan', value: 'Afghanistan', code: 'AF', dialingCode: '93'},
    {name: 'Albania', value: 'Albania', code: 'AL', dialingCode: '355'},
    {name: 'Algeria', value: 'Algeria', code: 'DZ', dialingCode: '213'},
    {name: 'Andorra', value: 'Andorra', code: 'AD', dialingCode: '376'},
    {name: 'Angola', value: 'Angola', code: 'AO', dialingCode: '244'},
    {name: 'Anguilla', value: 'Anguilla', code: 'AI', dialingCode: '1'},
    {name: 'Antigua and Barbuda', value: 'Antigua and Barbuda', code: 'AG', dialingCode: '1'},
    {name: 'Argentina', value: 'Argentina', code: 'AR', dialingCode: '54'},
    {name: 'Armenia', value: 'Armenia', code: 'AM', dialingCode: '374'},
    {name: 'Aruba', value: 'Aruba', code: 'AW', dialingCode: '297'},
    {name: 'Australia', value: 'Australia', code: 'AU', dialingCode: '61'},
    {name: 'Austria', value: 'Austria', code: 'AT', dialingCode: '43'},
    {name: 'Azerbaijan', value: 'Azerbaijan', code: 'AZ', dialingCode: '994'},
    {name: 'Bahamas', value: 'Bahamas', code: 'BS', dialingCode: '1'},
    {name: 'Bahrain', value: 'Bahrain', code: 'BH', dialingCode: '973'},
    {name: 'Bangladesh', value: 'Bangladesh', code: 'BD', dialingCode: '880'},
    {name: 'Barbados', value: 'Barbados', code: 'BB', dialingCode: '1'},
    {name: 'Belarus', value: 'Belarus', code: 'BY', dialingCode: '375'},
    {name: 'Belgium', value: 'Belgium', code: 'BE', dialingCode: '32'},
    {name: 'Belize', value: 'Belize', code: 'BZ', dialingCode: '501'},
    {name: 'Benin', value: 'Benin', code: 'BJ', dialingCode: '229'},
    {name: 'Bermuda', value: 'Bermuda', code: 'BM', dialingCode: '1'},
    {name: 'Bhutan', value: 'Bhutan', code: 'BT', dialingCode: '975'},
    {name: 'Bolivia', value: 'Bolivia', code: 'BO', dialingCode: '591'},
    {name: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina', code: 'BA', dialingCode: '387'},
    {name: 'Botswana', value: 'Botswana', code: 'BW', dialingCode: '267'},
    {name: 'Brazil', value: 'Brazil', code: 'BR', dialingCode: '55'},
    {name: 'British Virgin Islands', value: 'British Virgin Islands', code: 'VG', dialingCode: '1'},
    {name: 'Brunei Darussalam', value: 'Brunei Darussalam', code: 'BN', dialingCode: '673'},
    {name: 'Bulgaria', value: 'Bulgaria', code: 'BG', dialingCode: '359'},
    {name: 'Burkina Faso', value: 'Burkina Faso', code: 'BF', dialingCode: '226'},
    {name: 'Burundi', value: 'Burundi', code: 'BI', dialingCode: '257'},
    {name: 'Cambodia', value: 'Cambodia', code: 'KH', dialingCode: '855'},
    {name: 'Cameroon', value: 'Cameroon', code: 'CM', dialingCode: '237'},
    {name: 'Canada', value: 'Canada', code: 'CA', dialingCode: '1'},
    {name: 'Cape Verde', value: 'Cape Verde', code: 'CV', dialingCode: '238'},
    {name: 'Cayman Islands', value: 'Cayman Islands', code: 'KY', dialingCode: '1'},
    {name: 'Central African Republic', value: 'Central African Republic', code: 'CF', dialingCode: '236'},
    {name: 'Chad', value: 'Chad', code: 'TD', dialingCode: '235'},
    {name: 'Chile', value: 'Chile', code: 'CL', dialingCode: '56'},
    {name: 'China', value: 'China', code: 'CN', dialingCode: '86'},
    {name: 'Colombia', value: 'Colombia', code: 'CO', dialingCode: '57'},
    {name: 'Comoros', value: 'Comoros', code: 'KM', dialingCode: '269'},
    {name: 'Congo', value: 'Congo', code: 'CG', dialingCode: '242'},
    {name: 'Cook Islands', value: 'Cook Islands', code: 'CK', dialingCode: '682'},
    {name: 'Costa Rica', value: 'Costa Rica', code: 'CR', dialingCode: '506'},
    {name: 'Cote D\'Ivoire', value: 'Cote D\'Ivoire', code: 'CI', dialingCode: '225'},
    {name: 'Croatia', value: 'Croatia', code: 'HR', dialingCode: '385'},
    {name: 'Cuba', value: 'Cuba', code: 'CU', dialingCode: '53'},
    {name: 'Cyprus', value: 'Cyprus', code: 'CY', dialingCode: '357'},
    {name: 'Czech', value: 'Czech', code: 'CZ', dialingCode: '420'},
    {name: 'Denmark', value: 'Denmark', code: 'DK', dialingCode: '45'},
    {name: 'Djibouti', value: 'Djibouti', code: 'DJ', dialingCode: '253'},
    {name: 'Dominica', value: 'Dominica', code: 'DM', dialingCode: '1'},
    {name: 'Dominican Republic', value: 'Dominican Republic', code: 'DO', dialingCode: '1'},
    {name: 'DR Congo', value: 'DR Congo', code: 'CD', dialingCode: '243'},
    {name: 'Ecuador', value: 'Ecuador', code: 'EC', dialingCode: '593'},
    {name: 'Egypt', value: 'Egypt', code: 'EG', dialingCode: '20'},
    {name: 'El Salvador', value: 'El Salvador', code: 'SV', dialingCode: '503'},
    {name: 'Equatorial Guinea', value: 'Equatorial Guinea', code: 'GQ', dialingCode: '240'},
    {name: 'Eritrea', value: 'Eritrea', code: 'ER', dialingCode: '291'},
    {name: 'Estonia', value: 'Estonia', code: 'EE', dialingCode: '372'},
    {name: 'Ethiopia', value: 'Ethiopia', code: 'ET', dialingCode: '251'},
    {name: 'Faroe Islands', value: 'Faroe Islands', code: 'FO', dialingCode: '298'},
    {name: 'Fiji', value: 'Fiji', code: 'FJ', dialingCode: '679'},
    {name: 'Finland', value: 'Finland', code: 'FI', dialingCode: '358'},
    {name: 'France', value: 'France', code: 'FR', dialingCode: '33'},
    {name: 'French Guiana', value: 'French Guiana', code: 'GF', dialingCode: '594'},
    {name: 'French Polynesia', value: 'French Polynesia', code: 'PF', dialingCode: '689'},
    {name: 'FYROM', value: 'FYROM', code: 'MK', dialingCode: '389'},
    {name: 'Gabon', value: 'Gabon', code: 'GA', dialingCode: '241'},
    {name: 'Gambia', value: 'Gambia', code: 'GM', dialingCode: '220'},
    {name: 'Georgia', value: 'Georgia', code: 'GE', dialingCode: '995'},
    {name: 'Germany', value: 'Germany', code: 'DE', dialingCode: '49'},
    {name: 'Ghana', value: 'Ghana', code: 'GH', dialingCode: '233'},
    {name: 'Gibraltar', value: 'Gibraltar', code: 'GI', dialingCode: '350'},
    {name: 'Greece', value: 'Greece', code: 'GR', dialingCode: '30'},
    {name: 'Greenland', value: 'Greenland', code: 'GL', dialingCode: '299'},
    {name: 'Grenada', value: 'Grenada', code: 'GD', dialingCode: '1'},
    {name: 'Guadeloupe', value: 'Guadeloupe', code: 'GP', dialingCode: '590'},
    {name: 'Guatemala', value: 'Guatemala', code: 'GT', dialingCode: '502'},
    {name: 'Guinea', value: 'Guinea', code: 'GN', dialingCode: '224'},
    {name: 'Guinea-Bissau', value: 'Guinea-Bissau', code: 'GW', dialingCode: '245'},
    {name: 'Guyana', value: 'Guyana', code: 'GY', dialingCode: '592'},
    {name: 'Haiti', value: 'Haiti', code: 'HT', dialingCode: '509'},
    {name: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)', code: 'VA', dialingCode: '379'},
    {name: 'Honduras', value: 'Honduras', code: 'HN', dialingCode: '504'},
    {name: 'Hong Kong', value: 'Hong Kong', code: 'HK', dialingCode: '852'},
    {name: 'Hungary', value: 'Hungary', code: 'HU', dialingCode: '36'},
    {name: 'Iceland', value: 'Iceland', code: 'IS', dialingCode: '354'},
    {name: 'India', value: 'India', code: 'IN', dialingCode: '91'},
    {name: 'Indonesia', value: 'Indonesia', code: 'ID', dialingCode: '62'},
    {name: 'Iran', value: 'Iran', code: 'IR', dialingCode: '98'},
    {name: 'Iraq', value: 'Iraq', code: 'IQ', dialingCode: '964'},
    {name: 'Ireland', value: 'Ireland', code: 'IE', dialingCode: '353'},
    {name: 'Israel', value: 'Israel', code: 'IL', dialingCode: '972'},
    {name: 'Italy', value: 'Italy', code: 'IT', dialingCode: '39'},
    {name: 'Jamaica', value: 'Jamaica', code: 'JM', dialingCode: '1'},
    {name: 'Japan', value: 'Japan', code: 'JP', dialingCode: '81'},
    {name: 'Jordan', value: 'Jordan', code: 'JO', dialingCode: '962'},
    {name: 'Kazakhstan', value: 'Kazakhstan', code: 'KZ', dialingCode: '7'},
    {name: 'Kenya', value: 'Kenya', code: 'KE', dialingCode: '254'},
    {name: 'Kiribati', value: 'Kiribati', code: 'KI', dialingCode: '686'},
    {name: 'Korea', value: 'Korea', code: 'KR', dialingCode: '82'},
    {name: 'Kosovo', value: 'Kosovo', code: 'XK', dialingCode: '383'},
    {name: 'Kuwait', value: 'Kuwait', code: 'KW', dialingCode: '965'},
    {name: 'Kyrgyzstan', value: 'Kyrgyzstan', code: 'KG', dialingCode: '996'},
    {name: 'Lao People\'s Democratic Republic', value: 'Lao People\'s Democratic Republic', code: 'LA', dialingCode: '856'},
    {name: 'Latvia', value: 'Latvia', code: 'LV', dialingCode: '371'},
    {name: 'Lebanon', value: 'Lebanon', code: 'LB', dialingCode: '961'},
    {name: 'Lesotho', value: 'Lesotho', code: 'LS', dialingCode: '266'},
    {name: 'Liberia', value: 'Liberia', code: 'LR', dialingCode: '231'},
    {name: 'Libya', value: 'Libya', code: 'LY', dialingCode: '218'},
    {name: 'Liechtenstein', value: 'Liechtenstein', code: 'LI', dialingCode: '423'},
    {name: 'Lithuania', value: 'Lithuania', code: 'LT', dialingCode: '370'},
    {name: 'Luxembourg', value: 'Luxembourg', code: 'LU', dialingCode: '352'},
    {name: 'Macau', value: 'Macau', code: 'MO', dialingCode: '853'},
    {name: 'Madagascar', value: 'Madagascar', code: 'MG', dialingCode: '261'},
    {name: 'Malawi', value: 'Malawi', code: 'MW', dialingCode: '265'},
    {name: 'Malaysia', value: 'Malaysia', code: 'MY', dialingCode: '60'},
    {name: 'Maldives', value: 'Maldives', code: 'MV', dialingCode: '960'},
    {name: 'Mali', value: 'Mali', code: 'ML', dialingCode: '223'},
    {name: 'Malta', value: 'Malta', code: 'MT', dialingCode: '356'},
    {name: 'Marshall Islands', value: 'Marshall Islands', code: 'MH', dialingCode: '692'},
    {name: 'Mauritania', value: 'Mauritania', code: 'MR', dialingCode: '222'},
    {name: 'Mauritius', value: 'Mauritius', code: 'MU', dialingCode: '230'},
    {name: 'Mexico', value: 'Mexico', code: 'MX', dialingCode: '52'},
    {name: 'Micronesia, Federated States Of', value: 'Micronesia, Federated States Of', code: 'FM', dialingCode: '691'},
    {name: 'Moldova', value: 'Moldova', code: 'MD', dialingCode: '373'},
    {name: 'Monaco', value: 'Monaco', code: 'MC', dialingCode: '377'},
    {name: 'Mongolia', value: 'Mongolia', code: 'MN', dialingCode: '976'},
    {name: 'Montenegro', value: 'Montenegro', code: 'ME', dialingCode: '382'},
    {name: 'Montserrat', value: 'Montserrat', code: 'MS', dialingCode: '1'},
    {name: 'Morocco', value: 'Morocco', code: 'MA', dialingCode: '212'},
    {name: 'Mozambique', value: 'Mozambique', code: 'MZ', dialingCode: '258'},
    {name: 'Myanmar', value: 'Myanmar', code: 'MM', dialingCode: '95'},
    {name: 'Namibia', value: 'Namibia', code: 'NA', dialingCode: '264'},
    {name: 'Nauru', value: 'Nauru', code: 'NR', dialingCode: '674'},
    {name: 'Nepal', value: 'Nepal', code: 'NP', dialingCode: '977'},
    {name: 'Netherlands', value: 'Netherlands', code: 'NL', dialingCode: '31'},
    {name: 'Netherlands Antilles', value: 'Netherlands Antilles', code: 'AN', dialingCode: '599'},
    {name: 'New Caledonia', value: 'New Caledonia', code: 'NC', dialingCode: '687'},
    {name: 'New Zealand', value: 'New Zealand', code: 'NZ', dialingCode: '64'},
    {name: 'Nicaragua', value: 'Nicaragua', code: 'NI', dialingCode: '505'},
    {name: 'Niger', value: 'Niger', code: 'NE', dialingCode: '227'},
    {name: 'Nigeria', value: 'Nigeria', code: 'NG', dialingCode: '234'},
    {name: 'Niue', value: 'Niue', code: 'NU', dialingCode: '683'},
    {name: 'Norway', value: 'Norway', code: 'NO', dialingCode: '47'},
    {name: 'Oman', value: 'Oman', code: 'OM', dialingCode: '968'},
    {name: 'Pakistan', value: 'Pakistan', code: 'PK', dialingCode: '92'},
    {name: 'Palau', value: 'Palau', code: 'PW', dialingCode: '680'},
    {name: 'Panama', value: 'Panama', code: 'PA', dialingCode: '507'},
    {name: 'Papua New Guinea', value: 'Papua New Guinea', code: 'PG', dialingCode: '675'},
    {name: 'Paraguay', value: 'Paraguay', code: 'PY', dialingCode: '595'},
    {name: 'Peru', value: 'Peru', code: 'PE', dialingCode: '51'},
    {name: 'Philippines', value: 'Philippines', code: 'PH', dialingCode: '63'},
    {name: 'Poland', value: 'Poland', code: 'PL', dialingCode: '48'},
    {name: 'Portugal', value: 'Portugal', code: 'PT', dialingCode: '351'},
    {name: 'Puerto Rico', value: 'Puerto Rico', code: 'PR', dialingCode: '1'},
    {name: 'Qatar', value: 'Qatar', code: 'QA', dialingCode: '974'},
    {name: 'Reunion', value: 'Reunion', code: 'RE', dialingCode: '262'},
    {name: 'Romania', value: 'Romania', code: 'RO', dialingCode: '40'},
    {name: 'Russia', value: 'Russia', code: 'RU', dialingCode: '7'},
    {name: 'Rwanda', value: 'Rwanda', code: 'RW', dialingCode: '250'},
    {name: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis', code: 'KN', dialingCode: '1'},
    {name: 'Saint Lucia', value: 'Saint Lucia', code: 'LC', dialingCode: '1'},
    {name: 'Saint Vincent and The Grenadines', value: 'Saint Vincent and The Grenadines', code: 'VC', dialingCode: '1'},
    {name: 'Samoa', value: 'Samoa', code: 'WS', dialingCode: '685'},
    {name: 'San Marino', value: 'San Marino', code: 'SM', dialingCode: '378'},
    {name: 'Sao Tome and Principe', value: 'Sao Tome and Principe', code: 'ST', dialingCode: '239'},
    {name: 'Saudi Arabia', value: 'Saudi Arabia', code: 'SA', dialingCode: '966'},
    {name: 'Senegal', value: 'Senegal', code: 'SN', dialingCode: '221'},
    {name: 'Serbia', value: 'Serbia', code: 'RS', dialingCode: '381'},
    {name: 'Seychelles', value: 'Seychelles', code: 'SC', dialingCode: '248'},
    {name: 'Sierra Leone', value: 'Sierra Leone', code: 'SL', dialingCode: '232'},
    {name: 'Singapore', value: 'Singapore', code: 'SG', dialingCode: '65'},
    {name: 'Slovakia', value: 'Slovakia', code: 'SK', dialingCode: '421'},
    {name: 'Slovenia', value: 'Slovenia', code: 'SI', dialingCode: '386'},
    {name: 'Solomon Islands', value: 'Solomon Islands', code: 'SB', dialingCode: '677'},
    {name: 'Somalia', value: 'Somalia', code: 'SO', dialingCode: ''},
    {name: 'South Africa', value: 'South Africa', code: 'ZA', dialingCode: '27'},
    {name: 'South Sudan', value: 'South Sudan', code: 'SS', dialingCode: '211'},
    {name: 'Spain', value: 'Spain', code: 'ES', dialingCode: '34'},
    {name: 'Sri Lanka', value: 'Sri Lanka', code: 'LK', dialingCode: '94'},
    {name: 'Sudan', value: 'Sudan', code: 'SD', dialingCode: '249'},
    {name: 'Suriname', value: 'Suriname', code: 'SR', dialingCode: '597'},
    {name: 'Swaziland', value: 'Swaziland', code: 'SZ', dialingCode: '268'},
    {name: 'Sweden', value: 'Sweden', code: 'SE', dialingCode: '46'},
    {name: 'Switzerland', value: 'Switzerland', code: 'CH', dialingCode: '41'},
    {name: 'Syrian Arab Republic', value: 'Syrian Arab Republic', code: 'SY', dialingCode: '963'},
    {name: 'Taiwan', value: 'Taiwan', code: 'TW', dialingCode: '886'},
    {name: 'Tajikistan', value: 'Tajikistan', code: 'TJ', dialingCode: '992'},
    {name: 'Tanzania, United Republic Of', value: 'Tanzania, United Republic Of', code: 'TZ', dialingCode: '255'},
    {name: 'Thailand', value: 'Thailand', code: 'TH', dialingCode: '66'},
    {name: 'Timor-Leste', value: 'Timor-Leste', code: 'TL', dialingCode: '670'},
    {name: 'Togo', value: 'Togo', code: 'TG', dialingCode: '228'},
    {name: 'Tonga', value: 'Tonga', code: 'TO', dialingCode: '676'},
    {name: 'Trinidad and Tobago', value: 'Trinidad and Tobago', code: 'TT', dialingCode: '1'},
    {name: 'Tunisia', value: 'Tunisia', code: 'TN', dialingCode: '216'},
    {name: 'Türkiye', value: 'Türkiye', code: 'TR', dialingCode: '90'},
    {name: 'Turkmenistan', value: 'Turkmenistan', code: 'TM', dialingCode: '993'},
    {name: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands', code: 'TC', dialingCode: '1'},
    {name: 'Tuvalu', value: 'Tuvalu', code: 'TV', dialingCode: '688'},
    {name: 'Uganda', value: 'Uganda', code: 'UG', dialingCode: '256'},
    {name: 'Ukraine', value: 'Ukraine', code: 'UA', dialingCode: '380'},
    {name: 'United Arab Emirates', value: 'United Arab Emirates', code: 'AE', dialingCode: '971'},
    {name: 'United Kingdom', value: 'United Kingdom', code: 'GB', dialingCode: '44'},
    {name: 'Uruguay', value: 'Uruguay', code: 'UY', dialingCode: '598'},
    {name: 'USA', value: 'USA', code: 'US', dialingCode: '1'},
    {name: 'Uzbekistan', value: 'Uzbekistan', code: 'UZ', dialingCode: '998'},
    {name: 'Vanuatu', value: 'Vanuatu', code: 'VU', dialingCode: '678'},
    {name: 'Venezuela', value: 'Venezuela', code: 'VE', dialingCode: '58'},
    {name: 'Vietnam', value: 'Vietnam', code: 'VN', dialingCode: '84'},
    {name: 'Yemen', value: 'Yemen', code: 'YE', dialingCode: '967'},
    {name: 'Zambia', value: 'Zambia', code: 'ZM', dialingCode: '260'},
    {name: 'Zimbabwe', value: 'Zimbabwe', code: 'ZW', dialingCode: '263'},
];

export { COUNTRY_LIST };